export const emptyArr = []
export const safeArr = <T extends Array<unknown>>(arr: T | undefined): T =>
    Array.isArray(arr) ? arr : (emptyArr as T)

export const emptyObj = {}
export const safeObj = <T extends object>(obj: T | undefined): T =>
    typeof obj === 'object' && obj !== null ? obj : (emptyObj as T)
